import { CallToActionSplit } from "../../../../modules/content/components/CallToActionSplit/CallToActionSplit";
import { CallToActionStacked } from "../../../../modules/content/components/CallToActionStacked/CallToActionStacked";
import { SproutSection } from "../../../../modules/content/components/SproutSection/SproutSection";
import type { ICallToActionBlockProps } from "./CallToActionBlock.props";

export const CallToActionBlock = (props: ICallToActionBlockProps) => {
  const { anchorId, buttons, description, eyebrow, heading, image, parentClass, spacing, variant } =
    props;
  if (!eyebrow && !heading && !description && !buttons?.length && !image) return null;

  return (
    <SproutSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="sprout-chapter-tab sprout-paper-lift relative overflow-visible rounded-[2rem_2rem_2rem_0.5rem] border-2 border-navy-ink bg-sunflower p-7 pt-10 text-navy-ink md:p-12 md:pt-14 lg:p-16 lg:pt-16">
        {variant === "split" ? (
          <CallToActionSplit {...props} />
        ) : (
          <CallToActionStacked {...props} />
        )}
      </div>
    </SproutSection>
  );
};

CallToActionBlock.displayName = "Block::CallToActionBlock";
